import { configureStore, combineReducers } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { apiSlice } from "./RTK/postageSlice";
import { orderSlice } from "./RTK/orderManagementSlice";
import { veevaApi } from "./RTK/veevaReconcileSlice";
import { customFulfillmentSlice } from "./RTK/customFulfillmentSlice";
import { authSlice } from "./RTK/authSlice";
import { loaderSlice } from "./RTK/loaderSlice";

const persistConfig = {
  key: "root",
  storage,
  // There is an issue with redux-persist and RTK Query, so we need to blacklist the API slice
  blacklist: [
    apiSlice.reducerPath,
    orderSlice.reducerPath,
    veevaApi.reducerPath,
    customFulfillmentSlice.reducerPath,
  ],
};

const rootReducer = combineReducers({
  [apiSlice.reducerPath]: apiSlice.reducer,
  [orderSlice.reducerPath]: orderSlice.reducer,
  [veevaApi.reducerPath]: veevaApi.reducer,
  [customFulfillmentSlice.reducerPath]: customFulfillmentSlice.reducer,
  auth: authSlice.reducer,
  loader: loaderSlice.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(
      apiSlice.middleware,
      orderSlice.middleware,
      veevaApi.middleware,
      customFulfillmentSlice.middleware
    ),
});

export const persistor = persistStore(store);
